var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.locations
    ? _c("form", [
        _c("div", { staticClass: "dashboard-page-title" }, [
          _c("div", { staticClass: "container-fluid" }, [
            _c("h1", [_vm._v("Locations")]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-info",
                attrs: { "active-class": "" },
                on: {
                  click: function ($event) {
                    return _vm.$router.go(-1)
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-chevron-left" }),
                _vm._v(" Back\n      "),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "dashboard-block" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-10 col-lg-8" },
                [
                  _c("h2", [_vm._v("Based In")]),
                  _vm._v(" "),
                  _c("selectize", {
                    ref: "based_in",
                    staticClass: "selectize selectize-single",
                    attrs: {
                      name: "based_in",
                      groups: _vm.locationGroups,
                      options: _vm.locationOptions,
                    },
                    on: { input: _vm.getFilteredData },
                    model: {
                      value: _vm.stateBasedIn,
                      callback: function ($$v) {
                        _vm.stateBasedIn = $$v
                      },
                      expression: "stateBasedIn",
                    },
                  }),
                  _vm._v(" "),
                  this.stateLocationRegionBasedIn
                    ? _c(
                        "div",
                        [
                          _c("h3", [_vm._v("Select a region")]),
                          _vm._v(" "),
                          _c("selectize", {
                            ref: "region_based_in",
                            staticClass: "selectize selectize-single",
                            attrs: {
                              name: "region_based_in",
                              "key-context": "region_based_in",
                              "fetch-results":
                                _vm.handleGetLocationRegionsCallback,
                              "fetch-more-results":
                                _vm.handleGetNextLocationRegionsCallback,
                              options: _vm.basedInRegionOptions,
                            },
                            model: {
                              value: _vm.stateLocationRegionBasedIn,
                              callback: function ($$v) {
                                _vm.stateLocationRegionBasedIn = $$v
                              },
                              expression: "stateLocationRegionBasedIn",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "decorative-divider" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-10 col-lg-8" },
                [
                  _c("h2", [_vm._v("Available In")]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "large-checklist" },
                    _vm._l(_vm.locations, function (location) {
                      return _c("li", { key: location.id }, [
                        _c(
                          "div",
                          { staticClass: "checkbox checkbox-primary" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.stateLocations,
                                  expression: "stateLocations",
                                },
                              ],
                              attrs: {
                                type: "checkbox",
                                id: `checkbox-available-in-${location.id}`,
                              },
                              domProps: {
                                value: { id: location.id },
                                checked: Array.isArray(_vm.stateLocations)
                                  ? _vm._i(_vm.stateLocations, {
                                      id: location.id,
                                    }) > -1
                                  : _vm.stateLocations,
                              },
                              on: {
                                input: ($event) =>
                                  _vm.updateStateLocations(
                                    location,
                                    $event.target.checked
                                  ),
                                change: function ($event) {
                                  var $$a = _vm.stateLocations,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = { id: location.id },
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.stateLocations = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.stateLocations = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.stateLocations = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                attrs: {
                                  for: `checkbox-available-in-${location.id}`,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(location.name) +
                                    "\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            location.children && location.children.length > 0
                              ? _c(
                                  "ul",
                                  _vm._l(
                                    location.children,
                                    function (childLocation) {
                                      return _c(
                                        "li",
                                        { key: childLocation.id },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.stateLocations,
                                                expression: "stateLocations",
                                              },
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                              id: `checkbox-available-in-${childLocation.id}`,
                                            },
                                            domProps: {
                                              value: { id: childLocation.id },
                                              checked: Array.isArray(
                                                _vm.stateLocations
                                              )
                                                ? _vm._i(_vm.stateLocations, {
                                                    id: childLocation.id,
                                                  }) > -1
                                                : _vm.stateLocations,
                                            },
                                            on: {
                                              input: ($event) =>
                                                _vm.updateStateLocations(
                                                  childLocation,
                                                  $event.target.checked
                                                ),
                                              change: function ($event) {
                                                var $$a = _vm.stateLocations,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = {
                                                      id: childLocation.id,
                                                    },
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.stateLocations =
                                                        $$a.concat([$$v]))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.stateLocations = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.stateLocations = $$c
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              attrs: {
                                                for: `checkbox-available-in-${childLocation.id}`,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(childLocation.name) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]
                        ),
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "ladda-button",
                    {
                      staticClass: "btn btn-sm btn-primary",
                      attrs: {
                        type: "submit",
                        click: _vm.handleSaveLocationsCallback,
                      },
                    },
                    [_vm._v("\n            Save Changes\n          ")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }